/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LoyaltyRequestStatusEnum } from './loyaltyRequestStatusEnum';


/**
 * Получить заявку (сокращеная инфа).
 */
export interface LoyaltyRequestDtoShortView { 
    /**
     * ID записи.
     */
    id?: string;
    /**
     * название любимого места.
     */
    name?: string;
    /**
     * ID автора заявки.
     */
    userId?: string;
    /**
     * ID объединения автора.
     */
    parentOrganisationId?: string;
    /**
     * Дата создания.
     */
    createdDate?: string;
    status?: LoyaltyRequestStatusEnum;
}
export namespace LoyaltyRequestDtoShortView {
}


